type ProfileFormData = {
	name: string;
	email: string;
	document: string;
	phone: string;
	password: string;
	newPassword: string;
	code: string;
	currentPassword: string;
};

export const validation = (
	values: any,
	key: keyof ProfileFormData | "all",
): {
	name: string;
	errors: Array<{ isValidated: boolean; message: string }>;
} => {
	const isEmailValid = (email: string) => /\S+@\S+\.\S+/.test(email);
	const isCPFValid = (cpf: string) => /^\d{11}$/.test(cpf);
	const isCNPJValid = (cnpj: string) => /^\d{14}$/.test(cnpj);
	const isPhoneValid = (phone: string) => /^\+\d{13}$/.test(phone);

	switch (key) {
		case "name":
			return {
				name: "Nome",
				errors: [
					{
						isValidated: !!values[key],
						message: "Este campo é requerido",
					},
				],
			};
		case "email":
			return {
				name: "Email",
				errors: [
					{
						isValidated: !!values[key],
						message: "Este campo é requerido",
					},
					{
						isValidated: isEmailValid(values[key]),
						message: "Formato de e-mail inválido",
					},
				],
			};
		case "document":
			return {
				name: "CPF ou CNPJ",
				errors: [
					{
						isValidated: !!values[key],
						message: "Este campo é requerido",
					},
					{
						isValidated: isCPFValid(values[key]) || isCNPJValid(values[key]),
						message: "Formato de CPF ou CNPJ inválido",
					},
				],
			};
		case "phone":
			return {
				name: "Celular",
				errors: [
					{
						isValidated: !!values[key],
						message: "Este campo é requerido",
					},
					{
						isValidated: isPhoneValid(values[key]),
						message: "Formato de celular inválido. Use o formato xx xxxxxxxxx",
					},
				],
			};
		case "password":
			return {
				name: "Senha",
				errors: [
					{
						isValidated: !!values[key],
						message: "Este campo é requerido",
					},
					{
						isValidated: !!values[key] && values[key].length >= 8,
						message: "A senha deve ter ao menos 8 caracteres",
					},
				],
			};
		case "newPassword":
			return {
				name: "Nova senha",
				errors: [
					{
						isValidated: !!values[key],
						message: "Este campo é requerido",
					},
					{
						isValidated: !!values[key] && values[key].length >= 8,
						message: "A senha deve ter ao menos 8 caracteres",
					},
				],
			};
		case "currentPassword":
			return {
				name: "Senha",
				errors: [
					{
						isValidated: !!values[key],
						message: "Este campo é requerido",
					},
					{
						isValidated: !!values[key] && values[key].length >= 8,
						message: "A senha deve ter ao menos 8 caracteres",
					},
				],
			};
		case "code":
			return {
				name: "Código de confirmação",
				errors: [
					{
						isValidated: !!values[key],
						message: "Este campo é requerido",
					},
					{
						isValidated: !!values[key] && values[key].length === 6,
						message: "O código de verificação deve ter 6 caracteres",
					},
				],
			};

		case "all":
			// eslint-disable-next-line no-case-declarations
			let errors: any = [];
			for (const _key of Object.keys(values) as Array<keyof ProfileFormData>) {
				const validations = validation(values, _key);
				const newErrors = validations.errors.filter(
					(error: any) => !error.isValidated,
				);
				errors = [
					...errors,
					...newErrors.map((error) => ({
						...error,
						message: `${validations.name}: ${error.message}`,
					})),
				];
			}
			return {
				name: "Validação dos campos",
				errors,
			};
		default:
			return {
				name: "",
				errors: [],
			};
	}
};
